<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.HeightFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import {
  HEIGHT,
  HEIGHT_SIZE_LABEL,
} from '@/store/modules/cards/constants';

export default {
  name: 'HeightFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      return [{
        text: HEIGHT_SIZE_LABEL.SMALL,
        value: HEIGHT.SMALL,
      },
      {
        text: HEIGHT_SIZE_LABEL.MID,
        value: HEIGHT.MID,
      },
      {
        text: HEIGHT_SIZE_LABEL.LARGE,
        value: HEIGHT.LARGE,
      },
      {
        text: HEIGHT_SIZE_LABEL.XLARGE,
        value: HEIGHT.XLARGE,
      }];
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}
</style>
